module.exports = require("npm:object-path@0.9.2/index");